import { LinkUl } from './StyleConstants';
import { getAssetUrl } from 'lib/config/assetUrls';
import styles from './TechnicalSpecifications.module.css';

const technicalSpecificationsData = [
  {
    title: 'Body',
    data: [
      { name: 'Width', value: '8mm' },
      { name: 'Thickness', value: '2.45mm' },
    ],
    type: 'dualCol',
  },
  {
    title: 'Materials',
    data: [
      { name: 'Gold', value: '' },
      { name: 'Platinum', value: '' },
      { name: 'Water resistant up to 100m/328 ft', value: '' },
      {
        name: 'Non-allergenic, non-metallic, seamless hypoallergenic resin',
        value: '',
      },
    ],
    type: 'list',
  },
  {
    title: 'Connectivity',
    data: [
      { name: 'EMF-safe', value: '' },
      { name: 'Bluetooth low energy', value: '' },
      { name: 'Automatic firmware updates via UH app', value: '' },
    ],
    type: 'list',
  },
  {
    title: 'Battery & Power',
    data: [{ name: 'Up to 6 days of battery life', value: '' }],
    type: 'list',
  },
  {
    title: 'Sensors',
    data: [
      { name: '6DOF Motion Sensor', value: '' },
      {
        name: 'Photoplethysmography (PPG) sensor (For HR and blood oxygen)',
        value: '',
      },
      { name: 'Skin temperature sensor (Far infrared sensor)', value: '' },
    ],
    type: 'list',
  },
  {
    title: 'Other Key Specifications',
    data: [
      { name: 'Operating temp: -5 to 50°C', value: '' },
      { name: 'BLE transmission power: 0 dBM(1mw)', value: '' },
      { name: 'BLE frequency: 2402 to 2480MHz', value: '' },
    ],
    type: 'list',
  },
  {
    title: 'Download Brochure',
    data: [],
    type: 'cta',
  },
];

const ListCol = ({ listItems }: { listItems?: string[] }) => {
  return (
    <div className={styles.listCol}>
      <ul className="list">
          {listItems?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    );
};

const PCol = ({ data }: { data: string }) => {
  return <p className={styles.pCol}>{data}</p>;
};

const Title = ({ data }: { data: string }) => {
  return <p className={styles.title}>{data}</p>;
};

const DualCol = ({
  data,
}: {
  data: { name: string; value: string }[];
}) => {
  return (
    <div className={styles.dualCol}>
        {data.map((item, index) => {
          return (
            <p key={index} className="col">
              <span>{item.name}:</span> {item.value}
            </p>
          );
        })}
      </div>
    );
};

export const TechnicalSpecificationsRare = () => {
  return (
    <div className={styles.root}>
      <div className="tech-spec-container">
          <div className="head">
            <h3>technical specifications</h3>
          </div>
          <div className="specifications">
            {technicalSpecificationsData.map((item, index) => {
              return item.type !== 'cta' ? (
                <div className="row" key={index}>
                  <Title data={item.title} />
                  {item.type === 'dualCol' ? (
                    <DualCol data={item.data} />
                  ) : item.type === 'list' ? (
                    <ListCol listItems={item.data.map((item) => item.name)} />
                  ) : (
                    <PCol data={item.data[0].name} />
                  )}
                </div>
              ) : (
                <div className="download-brochure">
                  <LinkUl
                    href={getAssetUrl('/web_v2/rare/Ultrahuman-Rare.pdf')}
                    download="Ultrahuman-Rare"
                    target={'_blank'}
                    type="application/octet-stream"
                  >
                    {item.title}
                  </LinkUl>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
};
